module.exports = __webpack_public_path__ + "img/flight-selected.1ead08e2.svg";